import { createReducer, on } from '@ngrx/store';
import { newsItemActions } from '../actions/news-item.actions';
import { NewsItem } from '../models';

export interface NewsItemState {
    loaded: boolean | null;
    loading: boolean | null;
    saving: boolean;
    saved: boolean;
    error: number | null;
    newsItem: NewsItem | null;
}

export const initialState: NewsItemState = {
    loaded: null,
    loading: null,
    saving: false,
    saved: false,
    error: null,
    newsItem: null,
};

export const newsItemReducer = createReducer(
    initialState,
    on(newsItemActions.getNewsItem, (state): NewsItemState => ({
        ...state,
        loading: true,
        loaded: null,
        error: null,
    })),
    on(newsItemActions.getNewsItemSuccess, (state, { payload }): NewsItemState => ({
        ...state,
        loading: false,
        loaded: true,
        error: null,
        newsItem: payload,
    })),
    on(newsItemActions.getNewsItemError, (state, payload): NewsItemState => ({
        ...state,
        loading: false,
        loaded: false,
        error: payload.code,
    })),
    on(newsItemActions.createNewsItem, (state): NewsItemState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(newsItemActions.createNewsItemSuccess, (state, { payload }): NewsItemState => ({
        ...state,
        saving: false,
        saved: true,
        newsItem: payload,
    })),
    on(newsItemActions.createNewsItemError, (state): NewsItemState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    on(newsItemActions.updateNewsItem, (state): NewsItemState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(newsItemActions.updateNewsItemSuccess, (state, { payload }): NewsItemState => ({
        ...state,
        saving: false,
        saved: true,
        newsItem: payload,
    })),
    on(newsItemActions.updateNewsItemError, (state): NewsItemState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    on(newsItemActions.deleteNewsItem, (state): NewsItemState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(newsItemActions.deleteNewsItemSuccess, (state): NewsItemState => ({
        ...state,
        saving: false,
        saved: true,
        newsItem: null,
    })),
    on(newsItemActions.deleteNewsItemError, (state): NewsItemState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    on(newsItemActions.clear, (): NewsItemState => ({ ...initialState })),
);
